import { render, staticRenderFns } from "./QnrIntroGetStarted.vue?vue&type=template&id=5b14a56e&scoped=true&"
import script from "./QnrIntroGetStarted.vue?vue&type=script&lang=js&"
export * from "./QnrIntroGetStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b14a56e",
  null
  
)

export default component.exports